(function() {
  window.onload = function() {
    /********************************/
    /********* GENERAL **************/
    /********************************/

    var toggleVariableArray = {
      add(el, value) {el.push(value);},
      remove(el, value) {el.splice(el.indexOf(value), 1);}
    }

    var toggleElementClass = {
      add(el, value) {el.classList.add(value);},
      remove(el, value) {el.classList.remove(value);},
      toggle(el, value) {el.classList.toggle(value)}
    }

    // GLOBAL VARIABLES
    getViewportInfo();
    var currentUrl = window.location.href;
    var currentSearch = window.location.search.replace('?', '');
    var liquidEl = document.getElementById('liquid');
    var liquid = liquidEl.dataset.liquid;
    var headerHeight = 80;
    var mobMenuBtn = document.getElementById('mob-menu--btn');
    var mainNavMenu = document.getElementById('main-nav-menu');
    var storeLink = document.getElementById('store-link');
    var storeDropdown = document.getElementById('store-dropdown');
    var toggleCollectionsLink = document.getElementById('toggle-collections-link');
    var storeCollectionsDropdown = document.getElementById('store-collections');
    var toggleCategoriesLink = document.getElementById('toggle-categories-link');
    var storeCategoriesDropdown = document.getElementById('store-categories');
    var currencyFormSelectHead = document.getElementById('currency-form-select-head');
    var currencyFormSelectFoot = document.getElementById('currency-form-select-foot');
    var contactLink = document.getElementById('contact-link');
    var contactCloseLink = document.getElementById('contact-close-link');
    var contactSection = document.getElementById('contact-details');
    var footer = document.getElementById('footer');

    // GLOBAL LISTENERS
    window.addEventListener('resize', handleResize);
    currencyFormSelectHead.addEventListener('change', handleCurrencySelection);
    currencyFormSelectFoot.addEventListener('change', handleCurrencySelection);
    contactLink.addEventListener('click', toggleContactSection);
    contactCloseLink.addEventListener('click', toggleContactSection);
    booleanListeners();

    // GLOBAL FUNCTIONS
    function getViewportInfo() {
      viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      viewportOrientation = (viewportWidth > viewportHeight ? 'landscape' : 'portrait');
      viewportDevice = (viewportOrientation === 'portrait' || viewportWidth < 1024 ? 'touch' : 'desktop');
    }

    function booleanListeners() {
      if(viewportDevice === 'desktop') {
        if(mobMenuBtn) {
          mobMenuBtn.removeEventListener('click', toggleMobileMenu);
        }

        if(storeLink) {
          storeLink.removeEventListener('click', toggleStoreDropdown);
        }

        if(toggleCollectionsLink) {
          toggleCollectionsLink.removeEventListener('click', toggleCollectionsDropdown);
        }

        if(toggleCategoriesLink) {
          toggleCategoriesLink.removeEventListener('click', toggleCategoriesDropdown);
        }
      } else {
        if(mobMenuBtn) {
          mobMenuBtn.addEventListener('click', toggleMobileMenu);
        }

        if(storeLink) {
          storeLink.addEventListener('click', toggleStoreDropdown);
        }

        if(toggleCollectionsLink) {
          toggleCollectionsLink.addEventListener('click', toggleCollectionsDropdown);
        }

        if(toggleCategoriesLink) {
          toggleCategoriesLink.addEventListener('click', toggleCategoriesDropdown);
        }
      }
    }

    function handleResize() {
      getViewportInfo();

      booleanListeners();

      if(liquid === 'index') {
        handleIndexResize();
      } else if(liquid === 'collection') {
        handleCollectionResize();
      } else if(liquid === 'product') {
        handleProductResize();
      }
    }

    function handleCurrencySelection(evt) {
      evt.target.form.submit();
    }

    function toggleMobileMenu() {
      toggleElementClass.toggle(mobMenuBtn, 'is-open');
      toggleElementClass.toggle(mobMenuBtn, 'is-closed');
      toggleElementClass.toggle(mainNavMenu, 'is-open');
    }

    function toggleStoreDropdown(e) {
      e.preventDefault();

      toggleElementClass.toggle(storeLink, 'open');
      toggleElementClass.toggle(storeDropdown, 'open');
    }

    function toggleCollectionsDropdown(e) {
      e.preventDefault();

      toggleElementClass.toggle(toggleCollectionsLink, 'open');
      toggleElementClass.toggle(storeCollectionsDropdown, 'open');
      toggleElementClass.remove(toggleCategoriesLink, 'open');
      toggleElementClass.remove(storeCategoriesDropdown, 'open');
    }

    function toggleCategoriesDropdown(e) {
      e.preventDefault();

      toggleElementClass.toggle(toggleCategoriesLink, 'open');
      toggleElementClass.toggle(storeCategoriesDropdown, 'open');
      toggleElementClass.remove(toggleCollectionsLink, 'open');
      toggleElementClass.remove(storeCollectionsDropdown, 'open');
    }

    function toggleContactSection() {
      contactSection.classList.toggle('active');

    //   setTimeout(function() {
    //     window.scrollTo({
    //       top: document.body.scrollHeight,
    //       left: 0,
    //       behavior: 'smooth'
    //     });
    //   }, 250);
    }

    function handleTouchStart(e) {
      const firstTouch = getTouches(e)[0];
      xDown = firstTouch.clientX;
      xUp = false;
    }

    function handleTouchMove(e) {
      if(!xDown) {
        return;
      }

      var xUp = e.changedTouches[0].clientX;

      var xDiff = xDown - xUp;

      if(Math.abs(xDiff) > 2) {
        if(xDiff > 0) {
          // swipe left, move slider to next slide.
          var obj = {target:{dataset:{direction:'next'}}};

          if(liquid === 'index') {
            collectionProductSliderNav(obj);
          } else if(liquid === 'product') {
            productImagesSliderNav('next');
          }

        } else {
          // swipe right, move slider to previous slide.
          var obj = {target:{dataset:{direction:'prev'}}};

          if(liquid === 'index') {
            collectionProductSliderNav(obj);
          } else if(liquid === 'product') {
            productImagesSliderNav('prev');
          }
        }
      }

      xDown = null;
    }

    function handleTouchEnd(e) {
    }

    function getTouches(e) {
      return e.touches;
    }

    /********************************/
    /********* LOGIN.LIQUD **********/
    /********************************/

    if(liquid === 'login') {
      // VARIABLES
      var loginFormTitle = document.getElementById('login-title');
      var loginForm = document.getElementById('login-form');
      var resetFormTitle = document.getElementById('reset-customer-password-title');
      var resetPasswordLink = document.getElementById('reset-password-link');
      var resetPasswordForm = document.getElementById('reset-customer-password-form');

      // LISTENERS
      if(resetPasswordLink) {
        resetPasswordLink.addEventListener('click', handleResetPassword);
      }
      
      if(currentUrl.indexOf('recover') > -1) {
        handleResetPassword();
      }

      // FUNCTIONS
      function handleResetPassword() {
          console.log('reset-password-link');
        loginFormTitle.classList.add('hidden');
        loginForm.classList.add('hidden');

        resetFormTitle.classList.remove('hidden');
        resetPasswordForm.classList.remove('hidden');
      }
    }

    /********************************/
    /********* INDEX.LIQUD **********/
    /********************************/

    if(liquid === 'index') {
      // VARIABLES
      var mainBanner = document.getElementById('main-banner');
      var collectionSliderContainer = document.getElementById('collection-with-slider');
      var collectionSliderWrapper = document.getElementById('collection_product_slider');
      var collectionProductSlider = document.getElementById('collection_product_slides');
      var collectionProductSliderWrapper = collectionProductSlider.parentNode;
      var collectionProductSliderNavBtns = document.getElementsByClassName('collection_product_slides_nav');
      var collectionProductSliderPosition = 0;
      var xDown = null;
      var xUp = null;
      var infoScrollbar = document.getElementById('info-scrollbar');
      var infoScrollbarCloseBtn = document.getElementById('scrollbar-close__btn');
      var video = document.getElementById('main-video');
      var playPauseBtn = document.getElementById('play-pause');

      if(collectionProductSlider) {
        formatCollectionProductSlider();
      }

      // LISTENERS
      if(collectionProductSliderNavBtns && collectionProductSliderNavBtns.length > 0) {
        for(var i = 0; i < collectionProductSliderNavBtns.length; i++) {
          collectionProductSliderNavBtns[i].addEventListener('click', collectionProductSliderNav);
        }
      }

      if(collectionSliderContainer) {
        collectionProductSlider.addEventListener('touchstart', handleTouchStart, false);
        collectionProductSlider.addEventListener('touchmove', handleTouchMove, false);
        collectionProductSlider.addEventListener('touchend', handleTouchEnd, false);
      }

      if(infoScrollbarCloseBtn) {
        infoScrollbarCloseBtn.addEventListener('click', hideInfoScrollbar);
      }

      if(playPauseBtn) {
        playPauseBtn.addEventListener('click', playPauseVideo);
      }

      // ACTIONS
      var scrollbarMarquee = {
        init() {
          scrollbarMarquee.scrolling = true;
          scrollbarMarquee.messages = document.querySelectorAll('.scrollbar .message');
          scrollbarMarquee.greatestWidth = 0;

          for(var i = 0; i < scrollbarMarquee.messages.length; i++) {
            if(scrollbarMarquee.messages[i].clientWidth > scrollbarMarquee.greatestWidth) {
              scrollbarMarquee.greatestWidth = scrollbarMarquee.messages[i].clientWidth;
            }
          }

          scrollbarMarquee.greatestWidth += 200;
          scrollbarMarquee.combinedWidth = scrollbarMarquee.greatestWidth * scrollbarMarquee.messages.length;

          for(var i = 0; i < scrollbarMarquee.messages.length; i++) {
            scrollbarMarquee.messages[i].style.width = scrollbarMarquee.greatestWidth + 'px';
            scrollbarMarquee.messages[i].style.right = '-' + (i + 1) * scrollbarMarquee.greatestWidth + 'px';
          }

          scrollbarMarquee.loop();
        },
        loop() {
          for(var i = 0; i < scrollbarMarquee.messages.length; i++) {
            var x = parseFloat(scrollbarMarquee.messages[i].style.right);

            if(x >= viewportWidth && Math.abs(x) > scrollbarMarquee.combinedWidth) {
              scrollbarMarquee.messages[i].style.right = '-' + scrollbarMarquee.greatestWidth + 'px'
            } else {
              x++;

              scrollbarMarquee.messages[i].style.right = x + 'px';
            }
          }

          if(scrollbarMarquee.scrolling) {
            requestAnimationFrame(this.loop.bind(this));
          }
        },
        terminate() {
          for(var i = 0; i < scrollbarMarquee.messages.length; i++) {
            scrollbarMarquee.messages[i].removeAttribute('style');
          }

          scrollbarMarquee.scrolling = false;
        }
      };
      scrollbarMarquee.init();

      // FUNCTIONS
      function formatCollectionProductSlider() {
            var slides = collectionProductSlider.children;

            collectionProductSlider.style.width = (slides.length * 100) + '%';

            for(var i = 0; i < slides.length; i++) {
                var slide = slides[i];

                slide.style.width = (100 / slides.length) + '%';
            }

            toggleElementClass.add(collectionSliderContainer, 'formatted');
      }

      function collectionProductSliderNav(e) {
        var direction = e.target.dataset.direction;
        var movement = collectionProductSliderWrapper.clientWidth;

        if(direction === 'prev') {
          if(collectionProductSliderPosition > 0) {
            collectionProductSliderPosition--;
          } else {
            collectionProductSliderPosition = collectionProductSlider.children.length - 1;
          }
        } else if(direction === 'next') {
          if(collectionProductSliderPosition < collectionProductSlider.children.length - 1) {
            collectionProductSliderPosition++;
          } else {
            collectionProductSliderPosition = 0;
          }
        }

        var transform = -Math.abs(movement * collectionProductSliderPosition);

        collectionProductSlider.style.transform = 'translate3d(' + transform + 'px,0,0)';
      }

      function hideInfoScrollbar() {
        scrollbarMarquee.terminate();
        toggleElementClass.add(infoScrollbar, 'hide');

        if(viewportOrientation === 'landscape') {
          mainBanner.style['height'] = viewportHeight - headerHeight + 'px';
        }
      }

      function playPauseVideo() {
        if(video.paused == true) {
          video.play();
          toggleElementClass.add(playPauseBtn, 'playing');
          toggleElementClass.remove(playPauseBtn, 'paused');
        } else {
          video.pause();
          toggleElementClass.add(playPauseBtn, 'paused');
          toggleElementClass.remove(playPauseBtn, 'playing');
        }
      }

      function handleIndexResize() {
        if(viewportOrientation === 'landscape') {
          if(infoScrollbar.classList.value.indexOf('hide') > -1) {
            mainBanner.style['height'] = viewportHeight - headerHeight + 'px';
          } else {
            var infoScrollbarHeight = 20;
            mainBanner.style['height'] = viewportHeight - (headerHeight + infoScrollbarHeight) + 'px';
          }
        } else {
          mainBanner.style['height'] = '';
        }

        formatCollectionProductSlider();

        hideInfoScrollbar();
      }
    }

    /********************************/
    /****** COLLECTION.LIQUD ********/
    /********************************/
    
    if(liquid === 'collection') {
      // VARIABLES
      var productFilterLinks = document.getElementsByClassName('product-filter');
      var productSorterSelect = document.getElementById('product-sorter');
      var checkedFilters = {color:[], size:[], tag:[], price:[]};
      var toggleFiltersBtn = document.getElementById('toggle-filters__btn');
      var toggleFiltersBtnIcon = document.getElementById('toggle-filters__btn__icon');
      var sorterFilterActions = document.getElementById('sorter-filters__actions');
      var toggleFilterSectionBtn = document.getElementsByClassName('filter_section__btn');
      collectionBooleanListeners();

      // LISTENERS
      if(productFilterLinks && productFilterLinks.length > 0) {
        for(var i = 0; i < productFilterLinks.length; i++) {
          productFilterLinks[i].addEventListener('click', productFilterV2);
        }
      }

      // if(productSorterSelect) {
      //   productSorterSelect.addEventListener('change', productSorter);
      // }

      if(toggleFiltersBtn) {
        toggleFiltersBtn.addEventListener('click', toggleSorterFilterActions)
      }

      // ACTIONS
      if(currentSearch != null && currentSearch.length > 0) {
        var searchName = currentSearch.split('=')[0];
        var searchValue = currentSearch.split('=')[1];

        var search = {
          target: document.getElementById('product-filter-' + searchName),
          checked: true,
          rule: searchName,
          selectedFilter: searchValue.split('+').join(' ')
        }

        productFilter(null, search);
      }

      // FUNCTIONS
      function handleCollectionResize() {
        collectionBooleanListeners();
      }

      function collectionBooleanListeners() {
        if(viewportDevice === 'desktop') {
          if(toggleFilterSectionBtn && toggleFilterSectionBtn.length > 0) {
            for(var i = 0; i < toggleFilterSectionBtn.length; i++) {
              toggleFilterSectionBtn[i].removeEventListener('click', toggleFilterSection);
            }
          }
        } else {
          if(toggleFilterSectionBtn && toggleFilterSectionBtn.length > 0) {
            for(var i = 0; i < toggleFilterSectionBtn.length; i++) {
              toggleFilterSectionBtn[i].addEventListener('click', toggleFilterSection);
            }
          }
        }
      }

    function productFilterV2(e) {
        var target = e.target.classList.value.indexOf('product-filter') > -1 
            ? e.target 
            : e.target.closest('.product-filter');

        target.classList.value.indexOf('checked') > -1
            ? target.classList.remove('checked')
            : target.classList.add('checked');

        var selectedColors = [], selectedSizes = [], selectedTags = [];

        for (var i = 0; i < productFilterLinks.length; i++) {
            var productFilterLink = productFilterLinks[i];

            if (productFilterLink.classList.value.indexOf('checked') > -1) {
                if (productFilterLink.dataset.color && selectedColors.indexOf(productFilterLink.dataset.color) < 0) {
                    selectedColors.push(productFilterLink.dataset.color.toLowerCase());
                }

                if (productFilterLink.dataset.size && selectedSizes.indexOf(productFilterLink.dataset.size) < 0) {
                    selectedSizes.push(productFilterLink.dataset.size.toLowerCase());
                }

                if (productFilterLink.dataset.tag && selectedTags.indexOf(productFilterLink.dataset.tag) < 0) {
                    selectedTags.push(productFilterLink.dataset.tag.toLowerCase());
                }
            }
        }

        var products = document.getElementsByClassName('product-list-item');

        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            
            var productColors = product.dataset.color?.split(',').filter(Boolean) || [],
                productSizes = product.dataset.size?.split(',').filter(Boolean) || [],
                productTags = product.dataset.tag?.split(',').filter(Boolean) || [];

            var intersectingColors = productColors.filter(color => selectedColors.indexOf(color) !== -1),
                intersectingSizes = productSizes.filter(size => selectedSizes.indexOf(size) !== -1),
                intersectingTags = productTags.filter(tag => selectedTags.indexOf(tag) !== -1);

            var intersectingColorsInProductTitle = product.dataset.title.split(' ').filter(word => selectedColors.indexOf(word.toLowerCase()) !== -1),
                intersectingColorsInTags = productTags.filter(tag => selectedColors.indexOf(tag) !== -1);
            
            var noColorMatch = 
                selectedColors.length > 0 && 
                intersectingColors.length === 0 && 
                intersectingColorsInProductTitle.length === 0 && 
                intersectingColorsInTags.length === 0 
                ? true : false;

            var noSizeMatch = selectedSizes.length > 0 && intersectingSizes.length === 0 ? true : false;

            var noTagMatch = selectedTags.length > 0 && intersectingTags.length === 0 ? true : false;

            noColorMatch || noSizeMatch || noTagMatch
                ? product.classList.add('hidden')
                : product.classList.remove('hidden');
        }

        if (target.dataset.rule === 'price') {
            products = Array.prototype.slice.call(products);

            if (target.dataset.price === 'low-to-high') {
                target.nextElementSibling.classList.remove('checked');
                products.sort((a, b) => { return a.dataset.price - b.dataset.price; });
            } else {
                target.previousElementSibling.classList.remove('checked');
                products.sort((a, b) => { return b.dataset.price - a.dataset.price; });
            }

            var productList = document.getElementById('product-list');

            for (var i = 0; i < products.length; i++) {
                productList.appendChild(products[i]);
            }
        }
    }

      function productFilter(e, search) {
        
        if(search) {
          var target = search.target;
          var checked = search.checked;
          var rule = search.rule;
          var selectedFilter = search.selectedFilter;
        } else {
          var target = (e.target.classList.value.indexOf('product-filter') > -1 ? e.target : e.target.closest('.product-filter'));

          var checked = (target.classList.value.indexOf('checked') > -1 ? false : true);

          /*
           * mark checked as false if indexOf class 'checked' as it will be removed. true prior to toggle.
           */

          var rule = target.dataset.rule;

          var selectedFilter = target.dataset[rule].toLowerCase();
        }

        if(checked) {
          toggleElementClass.add(target, 'checked');
        } else {
          toggleElementClass.remove(target, 'checked');
        }

        if(checked && checkedFilters[rule].indexOf(selectedFilter) === -1) {
          toggleVariableArray.add(checkedFilters[rule], selectedFilter);
        } else if(!checked) {
          toggleVariableArray.remove(checkedFilters[rule], selectedFilter);
        }

        var products = document.getElementsByClassName('product-list-item');

        if(rule != 'price') {
          for(var i = 0; i < products.length; i++) {
            var product = products[i];

            toggleElementClass.remove(product, 'init_' + rule);

            /*
             * Convert dataset to array
             */
            if(product.dataset[rule] && product.dataset[rule].indexOf(',') > -1) {
              var productData = product.dataset[rule].split(',');
            } else if(product.dataset[rule]) {
              var productData = [product.dataset[rule]];
            } else {
              var productData = [];
            }

            /*
             * Append data-tags to data to be checked. EG if no data-color (taken from variants) then tags might include color.
             */
            if(productData.length === 0) {
              if(product.dataset.tag && product.dataset.tag.indexOf(',') > -1) {
                productData.push(product.dataset.tag.split(','));
              } else {
                productData.push(product.dataset.tag);
              }
            }

            var productTitle = product.dataset.title;
            /*
             * Check product title & dataset attribute for match
             */
            if(checked && productTitle.indexOf(selectedFilter) > -1) {
              toggleElementClass.remove(product, rule + '_match_false');
            } else if(productData.length > 0) {
              var found = productData.some(r => checkedFilters[rule].indexOf(r) > -1);

              if(found || checkedFilters[rule].length === 0) {
                toggleElementClass.remove(product, rule + '_match_false');
              } else {
                toggleElementClass.add(product, rule + '_match_false');
              }
            } else {
              if(checkedFilters[rule].length > 0) {
                toggleElementClass.add(product, rule + '_match_false');
              } else {
                toggleElementClass.remove(product, rule + '_match_false');
              }
            }
          }
        } else {
          if(target.nextElementSibling) {
            toggleElementClass.remove(target.nextElementSibling, 'checked');
          } else if(target.previousElementSibling) {
            toggleElementClass.remove(target.previousElementSibling, 'checked');
          }

          products = Array.prototype.slice.call(products);
          if(selectedFilter === 'low-to-high') {
            products.sort((a, b) => { return a.dataset.price - b.dataset.price; });
          } else {
            products.sort((a, b) => { return b.dataset.price - a.dataset.price; });
          }

          var productList = document.getElementById('product-list');
          for(var i = 0; i < products.length; i++) {
            productList.appendChild(products[i]);
          }
        }
      }

      function productSorter(e) {
        window.location.href = 'https://dr-banana.myshopify.com/collections/all?sort_by=' + e.target.value;
      }

      function toggleSorterFilterActions(e) {
        if(sorterFilterActions.classList.value.indexOf('visible') > -1) {
          toggleElementClass.remove(sorterFilterActions, 'visible');
          toggleElementClass.remove(toggleFiltersBtn, 'active');
        } else {
          toggleElementClass.add(sorterFilterActions, 'visible');
          toggleElementClass.add(toggleFiltersBtn, 'active');
        }
      }

      function toggleFilterSection(e) {
        if(e.target.classList.value.indexOf('filter_section__btn') === -1) {
          var target = e.target.parentElement;
          var targetClassList = target.classList.value;
        } else {
          var target = e.target;
          var targetClassList = target.classList.value;
        }

        var targetParent = target.parentElement;
        var targetParentClassList = targetParent.classList.value;

        if(targetParentClassList.indexOf('active') > -1) {
          toggleElementClass.remove(targetParent, 'active');
        } else {
          toggleElementClass.add(targetParent, 'active');
        }
      }
    }

    /********************************/
    /******** PRODUCT.LIQUD *********/
    /********************************/
    
    if(liquid === 'product') {
      // VARIABLES
      var buyItNowButton = document.getElementById('buy-it-now');
      var productSelect = document.getElementById('productSelect');
      var productQuantity = document.getElementById('Quantity');
      var accordionPanels = document.getElementsByClassName('accordion-panel');
      var productDetails = document.getElementById('product-details');
      var productImagesContainer = document.getElementById('product-images');
      var productImages = productImagesContainer.children;
      var productImagesSliderPosition = 0;
      var productImagesSliderPositionIndicator = document.getElementById('product-images-slider-position-indicator');
      var header = document.getElementById('header');

      // LISTENERS
      if(buyItNowButton) {
        buyItNowButton.addEventListener('click', buyItNow);
      }

      if(accordionPanels && accordionPanels.length > 0) {
        for(var i = 0; i < accordionPanels.length; i++) {
          accordionPanels[i].addEventListener('click', accordionNav)
        }
      }

      productBooleanListeners();

      // ACTIONS
      formatProductImages();

      // FUNCTIONS
      function handleProductResize() {
        productBooleanListeners();

        formatProductImages();
      }

      function productBooleanListeners() {
        if(viewportDevice === 'desktop') {
          document.addEventListener('scroll', handleScroll);

          productImagesContainer.removeEventListener('touchstart', handleTouchStart, false);
          productImagesContainer.removeEventListener('touchmove', handleTouchMove, false);
          productImagesContainer.removeEventListener('touchend', handleTouchEnd, false);
        } else {
          productImagesContainer.addEventListener('touchstart', handleTouchStart, false);
          productImagesContainer.addEventListener('touchmove', handleTouchMove, false);
          productImagesContainer.addEventListener('touchend', handleTouchEnd, false);

          document.removeEventListener('scroll', handleScroll);
        }
      }

      function formatProductImages() {
        if(viewportDevice === 'desktop') {
          productImagesContainer.removeAttribute('style');

          for(var i = 0; i < productImages.length; i++) {
            var productImage = productImages[i];

            productImage.removeAttribute('style');
          }
        } else {
          productImagesContainer.style.width = viewportWidth * productImages.length + 'px';

          for(var i = 0; i < productImages.length; i++) {
            var productImage = productImages[i];

            productImage.style.width = viewportWidth + 'px';
          }
        }
      }

      function productImagesSliderNav(direction) {
        if(direction === 'prev') {
          if(productImagesSliderPosition > 0) {
            productImagesSliderPosition--;
          } else {
            productImagesSliderPosition = productImages.length - 1;
          }
        } else if(direction === 'next') {
          if(productImagesSliderPosition < productImages.length - 1) {
            productImagesSliderPosition++;
          } else {
            productImagesSliderPosition = 0;
          }
        }

        var transform = -Math.abs(viewportWidth * productImagesSliderPosition);

        productImagesContainer.style.transform = 'translate3d(' + transform + 'px,0,0)';

        productImagesSliderPositionIndicator.setAttribute('data-active-slide', productImagesSliderPosition);
      }

      function buyItNow() {
        var pid = productSelect.value;
        var qty = productQuantity.value;
        window.location.href = 'https://dr-banana.myshopify.com/cart/'+ pid +':'+ qty +'?channel=buy_button';
      }

      function accordionNav(e) {
        var clickedPanel = e.target.dataset.panel;

        for(var i = 0; i < accordionPanels.length; i++) {
          var curPanel = accordionPanels[i];

          if(curPanel.dataset.panel == clickedPanel) {
            if(curPanel.classList.value.indexOf('active') > -1) {
              toggleElementClass.remove(curPanel, 'active');
            } else {
              toggleElementClass.add(curPanel, 'active');
            }
          } else {
            toggleElementClass.remove(curPanel, 'active');
          }
        }

        handleScroll();
      }

      function handleScroll() {
        var productDetailsHeight = productDetails.getBoundingClientRect().height;
        var productDetailsPosTop = (viewportHeight - productDetailsHeight) / 2;
        var scrollTop = Math.abs(document.body.getBoundingClientRect().top);

        if(scrollTop < headerHeight) {
          if(productDetailsPosTop <= headerHeight) {
            // product details overlapping header.
            toggleElementClass.remove(productDetails, 'bottom');
            productDetails.style.top = 'calc(50% + '+ headerHeight +'px)';
          } else {
            // no overlap.
            productDetails.removeAttribute('style');
          }
        } else if(scrollTop + viewportHeight > (headerHeight + productImagesContainer.getBoundingClientRect().height)) {
          productDetails.removeAttribute('style');
          toggleElementClass.add(productDetails, 'bottom');
        } else {
          productDetails.removeAttribute('style');
          toggleElementClass.remove(productDetails, 'bottom');
        }
      }
    }

    /********************************/
    /******** RECORDS.LIQUD *********/
    /********************************/

    if(liquid === 'records') {
        var toggledTrackAudioSlot = document.getElementById('toggled-track-audio');
        var toggledTrackAudioSrcSlot = document.getElementById('toggled-track-audio-src');
        var toggledTrackArtworkSlot = document.getElementById('toggled-track-artwork');
        var drbTracks = document.getElementsByClassName('drb-track');

        // LISTENERS
        for(var i = 0; i < drbTracks.length; i++) {
            drbTracks[i].addEventListener('click', toggleTrackPlayback);
        }

        toggledTrackAudioSlot.addEventListener('contextmenu', e => {
            e.preventDefault();
        });

        // FUNCTIONS
        
        function toggleTrackPlayback(e) {
            for(var i = 0; i < drbTracks.length; i++) {
                drbTracks[i].classList.remove('active');
            }

            toggledTrackAudioSrcSlot.src = e.target.closest('.drb-track').dataset.trackUrl;
            toggledTrackArtworkSlot.src = e.target.closest('.drb-track').dataset.assetUrl;

            toggledTrackAudioSlot.load();

            e.target.closest('.drb-track').classList.add('active')

            toggledTrackAudioSlot.addEventListener('loadeddata', function() {
                if(toggledTrackAudioSlot.readyState >= 2) {
                toggledTrackAudioSlot.play();
                }
            });
        }
    }
  }
})();
